import qs from 'qs';

export default function qsParse<Q extends Record<string, any>>(
  query?: string,
  options: qs.IParseOptions = {},
): Q {
  if (!query) {
    // @ts-ignore
    return {};
  }

  return qs.parse(query[0] === '?' ? query.slice(1) : query, {
    // @ts-ignore
    arrayFormat: 'brackets',
    skipNulls: true,
    ...options,
  }) as Q;
}
